import { SVGProps } from 'react';

import { ReactComponent as VirtualBgIcon } from './virtualBackground.svg';

export type IconName = 'virtual-bg';

type IconConfig = {
  component: React.FunctionComponent<SVGProps<SVGSVGElement>>;
};

export const svgIconsConfig: Record<IconName, IconConfig> = {
  'virtual-bg': { component: VirtualBgIcon },
};
